export default () => {
  const isEdge = window.navigator.userAgent.indexOf('Edge') != -1;
  return window.navigator.userAgent.indexOf('Trident') != -1 && !isEdge;
};
